import { combineReducers } from 'redux';

import forcePlateDashboardUiReducer from './forcePlateDashboardUiReducer';
import forcePlateDashboardDataReducer from './forcePlateDashboardDataReducer';

export default combineReducers({
  ui: forcePlateDashboardUiReducer,
  data: forcePlateDashboardDataReducer,
});
